"use client";

import { useModularPermissionsStore } from "@/features/mod-perms/stores/modular-permissions.store";
import { useUIStore } from "@/stores/ui-states.store";
import {
  DelegateAddType,
  PlatformEnum,
} from "@/types/modular-permissions.types";
import { HexString } from "@/types/general.types";
import { usePathname, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import { useAccount } from "wagmi";

export const useCheckForSocialAccount = () => {
  const wagmiAcc = useAccount();

  const addDelegate = useModularPermissionsStore(
    (state) => state.addDelegation,
  );

  const addQueries = useModularPermissionsStore(
    (store) => store.setSocialDelegateQueryParams,
  );

  const router = useRouter();
  const pathname = usePathname();

  const [isLoaded, setIsLoaded] = useState(false);

  const { isSocialAccountBeingCreated, setIsSocialAccountBeingCreated } =
    useUIStore();

  useEffect(() => {
    if (!isSocialAccountBeingCreated) {
      const searchParams = new URLSearchParams(window.location.search);
      //? Get query params
      const platform = searchParams!.get("platform");
      const userId = searchParams!.get("hashedId");
      const account = searchParams!.get("aaAddress");

      //? If the params all exist then continue
      if (platform && userId && account) {
        setIsSocialAccountBeingCreated(true);

        //? Store the queries in state for later use
        addQueries({
          platform: platform as PlatformEnum,
          userId: userId as string,
          account: account as HexString,
        });

        //? Prepare the data
        const toSend = {
          vault: wagmiAcc.address as HexString,
          walletAddress: account as HexString,
          isSocialAccount: true,
          platform: platform as PlatformEnum,
          userId: userId,
        } as DelegateAddType;

        //? Create the delegat permission card
        addDelegate(toSend);
      } else {
        router.replace(pathname!);
        setIsSocialAccountBeingCreated(false);
      }

      //? Set state to finally loaded
      setIsLoaded(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wagmiAcc.address]);

  return {
    isSocialAccountBeingCreated,
    isLoaded,
  };
};
